import React, { useState } from 'react';
import { FaFileExcel, FaSearch } from 'react-icons/fa';
import CustomDatePicker from '../../../../../../components/common/CustomDatePicker/CustomDatePicker';
import CheckboxMultiSelect from '../../../../../../components/common/CheckboxMultiSelect/CheckboxMultiSelect';
import TableSearchBar from '../../../../../../components/common/Table/TableSearchBar';
import { PriceChange, ViewMode } from '../../types';

export interface FilterOption {
  value: any;
  label: string;
}

interface FilterBarProps {
  searchFilteredData: PriceChange[];
  setSearchFilteredData: (data: PriceChange[]) => void;
  startDate: string;
  endDate: string;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  userOptions: FilterOption[];
  selectedUsers: FilterOption[];
  onUsersChange: (users: FilterOption[]) => void;
  priceTypeOptions: FilterOption[];
  selectedPriceTypes: FilterOption[];
  onPriceTypesChange: (types: FilterOption[]) => void;
  changeTypeOptions: FilterOption[];
  selectedChangeTypes: FilterOption[];
  onChangeTypesChange: (types: FilterOption[]) => void;
  onExportToExcel?: () => void;
  exportDisabled?: boolean;
  totalChanges?: number;
  currentView: ViewMode;
  loading: boolean;
}

const FilterBar: React.FC<FilterBarProps> = ({
  searchFilteredData,
  setSearchFilteredData,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  userOptions,
  selectedUsers,
  onUsersChange,
  priceTypeOptions,
  selectedPriceTypes,
  onPriceTypesChange,
  changeTypeOptions,
  selectedChangeTypes,
  onChangeTypesChange,
  onExportToExcel,
  exportDisabled = false,
  totalChanges = 0,
  currentView,
  loading,
}) => {
  return (
    <div className="mp-toolbar">
      {/* Row 1: Search + Date pickers + Export */}
      <div className="flex flex-wrap items-center gap-2 lg:gap-3">
        {currentView === 'table' && !loading && (
          <div className="flex-1 min-w-[180px] lg:min-w-[220px] max-w-[380px] relative">
            <TableSearchBar
              data={searchFilteredData}
              updateFilteredData={setSearchFilteredData}
              searchFields={['product_name', 'user_name']}
              placeholder="Buscar por producto o usuario..."
            />
          </div>
        )}

        <div className="flex items-center gap-2">
          <CustomDatePicker value={startDate} onChange={setStartDate} placeholder="Desde" />
          <CustomDatePicker value={endDate} onChange={setEndDate} placeholder="Hasta" />
        </div>

        {onExportToExcel && (
          <button
            className="mp-btn-export ml-auto"
            onClick={onExportToExcel}
            disabled={exportDisabled || totalChanges === 0}
          >
            <FaFileExcel />
            <span>Excel</span>
          </button>
        )}
      </div>

      {/* Row 2: Filter dropdowns */}
      <div className="flex items-center gap-2 flex-wrap mt-3 pt-3" style={{ borderTop: '1px solid var(--border-color)' }}>
        <span className="text-xs font-semibold uppercase tracking-wider opacity-35 mr-1">Filtrar:</span>
        <div className="min-w-[130px]">
          <CheckboxMultiSelect
            options={userOptions}
            value={selectedUsers}
            onChange={onUsersChange}
            placeholder="Usuarios"
          />
        </div>
        <div className="min-w-[110px]">
          <CheckboxMultiSelect
            options={priceTypeOptions}
            value={selectedPriceTypes}
            onChange={onPriceTypesChange}
            placeholder="Tipo de Precio"
          />
        </div>
        <div className="min-w-[110px]">
          <CheckboxMultiSelect
            options={changeTypeOptions}
            value={selectedChangeTypes}
            onChange={onChangeTypesChange}
            placeholder="Tipo de Cambio"
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
